import EmployeeForm from "./addEmployee";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  refreshFunction?: Function;
};

const AddEmployee = ({ toggleModal, urlTittle, refreshFunction }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Carga de Empleado"}
        titleStyle={styles}
        urlTittle={urlTittle}
      >
        <EmployeeForm refreshFunction={refreshFunction} />
      </Modal>
    </>
  );
};

export default AddEmployee;
